import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-theme"]
const _hoisted_2 = { class: "layout-content-wrapper" }
const _hoisted_3 = { class: "layout-content flex flex-column align-items-center" }
const _hoisted_4 = { class: "confirmation-content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-triangle mr-3",
  style: {"font-size":"2rem"}
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "layout-mask modal-in" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DevBar = _resolveComponent("DevBar")!
  const _component_TopBar = _resolveComponent("TopBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_SearchComponent = _resolveComponent("SearchComponent")!
  const _component_HistoryComponent = _resolveComponent("HistoryComponent")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_KoruBlock = _resolveComponent("KoruBlock")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_PwaUpdateComponent = _resolveComponent("PwaUpdateComponent")!
  const _component_OfflineToggleComponent = _resolveComponent("OfflineToggleComponent")!
  const _component_BedrockHolder = _resolveComponent("BedrockHolder")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.containerClass),
    "data-theme": _ctx.getColorScheme,
    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDocumentClick()))
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.environment === 'development')
        ? (_openBlock(), _createBlock(_component_DevBar, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_TopBar, {
        topbarNotificationMenuActive: _ctx.topbarNotificationMenuActive,
        topbarUserMenuActive: _ctx.topbarUserMenuActive,
        topbarThemeMenuActive: _ctx.topbarThemeMenuActive,
        topbarLangMenuActive: _ctx.topbarLangMenuActive,
        onMenuButtonClick: _ctx.onMenuButtonClick,
        onSearchClick: _ctx.toggleSearch,
        onTopbarNotification: _ctx.onTopbarNotificationMenuButtonClick,
        onTopbarUserMenu: _ctx.onTopbarUserMenuButtonClick,
        onTopbarThemeMenu: _ctx.onTopbarThemeMenuButtonClick,
        onTopbarLangMenu: _ctx.onTopbarLangMenuButtonClick,
        onRightMenuClick: _ctx.onRightMenuButtonClick,
        onRightMenubuttonClick: _ctx.onRightMenuButtonClick
      }, null, 8, ["topbarNotificationMenuActive", "topbarUserMenuActive", "topbarThemeMenuActive", "topbarLangMenuActive", "onMenuButtonClick", "onSearchClick", "onTopbarNotification", "onTopbarUserMenu", "onTopbarThemeMenu", "onTopbarLangMenu", "onRightMenuClick", "onRightMenubuttonClick"]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.$route.path
        }))
      ]),
      (_ctx.config.app.search === true)
        ? (_openBlock(), _createBlock(_component_SearchComponent, {
            key: 1,
            searchActive: _ctx.searchActive,
            onSearchClick: _ctx.onSearchClick,
            onSearchHide: _ctx.onSearchHide
          }, null, 8, ["searchActive", "onSearchClick", "onSearchHide"]))
        : _createCommentVNode("", true),
      _createVNode(_component_HistoryComponent, {
        rightMenuActive: _ctx.rightMenuActive,
        "onUpdate:rightMenuActive": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rightMenuActive) = $event)),
        onRightMenuClick: _ctx.onRightMenuClick
      }, null, 8, ["rightMenuActive", "onRightMenuClick"]),
      _createVNode(_component_Toast, {
        group: "bedrock",
        autoZIndex: false
      }),
      _createVNode(_component_ConfirmPopup),
      _createVNode(_component_Footer),
      _createVNode(_component_KoruBlock, {
        blocked: _ctx.store.getters[_ctx.storeTypes.getters.isLoading]
      }, null, 8, ["blocked"]),
      _createVNode(_component_Dialog, {
        closable: false,
        header: _ctx.t('dialog.editingTitle'),
        modal: true,
        style: { width: '450px' },
        visible: _ctx.store.getters[_ctx.storeTypes.getters.showEditingDialog]
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "p-button-text",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.store.commit(_ctx.storeTypes.mutations.closeEditingDialog))),
            icon: "pi pi-times",
            label: _ctx.t('gen.no')
          }, null, 8, ["label"]),
          _createVNode(_component_Button, {
            class: "p-button-text",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.Navigation.navigateWithConfirm())),
            icon: "pi pi-check",
            label: _ctx.t('gen.yes')
          }, null, 8, ["label"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_ctx.t("dialog.editingConfirm")), 1)
          ])
        ]),
        _: 1
      }, 8, ["header", "visible"]),
      _createVNode(_component_PwaUpdateComponent),
      (_ctx.config.database.offlineMode === true && _ctx.user.canViewUI('offline'))
        ? (_openBlock(), _createBlock(_component_OfflineToggleComponent, { key: 2 }))
        : _createCommentVNode("", true),
      _createVNode(_component_BedrockHolder)
    ]),
    _createVNode(_component_Menu, {
      model: _ctx.menu,
      layoutMode: _ctx.layoutMode,
      active: _ctx.menuActive,
      mobileMenuActive: _ctx.staticMenuMobileActive,
      onMenuClick: _ctx.onMenuClick,
      onMenuitemClick: _ctx.onMenuItemClick,
      onRootMenuitemClick: _ctx.onRootMenuItemClick
    }, null, 8, ["model", "layoutMode", "active", "mobileMenuActive", "onMenuClick", "onMenuitemClick", "onRootMenuitemClick"]),
    _hoisted_6
  ], 10, _hoisted_1))
}